/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UnansweredCommentsTabContainer_story = {
    readonly id: string;
    readonly isClosed: boolean;
    readonly settings: {
        readonly live: {
            readonly enabled: boolean;
        };
    };
    readonly commentCounts: {
        readonly tags: {
            readonly UNANSWERED: number;
        };
    };
    readonly comments: {
        readonly viewNewEdges: ReadonlyArray<{
            readonly cursor: unknown;
            readonly node: {
                readonly enteredLive: boolean | null;
                readonly id: string;
                readonly " $fragmentRefs": FragmentRefs<"CommentContainer_comment" | "ReplyListContainer1_comment" | "IgnoredTombstoneOrHideContainer_comment">;
            };
        }> | null;
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly enteredLive: boolean | null;
                readonly id: string;
                readonly " $fragmentRefs": FragmentRefs<"CommentContainer_comment" | "ReplyListContainer1_comment" | "IgnoredTombstoneOrHideContainer_comment">;
            };
        }>;
    };
    readonly " $fragmentRefs": FragmentRefs<"PostCommentFormContainer_story" | "CommentContainer_story" | "ReplyListContainer1_story" | "CreateCommentReplyMutation_story" | "CreateCommentMutation_story">;
    readonly " $refType": "UnansweredCommentsTabContainer_story";
};
export type UnansweredCommentsTabContainer_story$data = UnansweredCommentsTabContainer_story;
export type UnansweredCommentsTabContainer_story$key = {
    readonly " $data"?: UnansweredCommentsTabContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"UnansweredCommentsTabContainer_story">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v1 = ({
        "args": null,
        "kind": "FragmentSpread",
        "name": "CommentContainer_comment"
    } as any), v2 = ({
        "args": null,
        "kind": "FragmentSpread",
        "name": "ReplyListContainer1_comment"
    } as any), v3 = ({
        "args": null,
        "kind": "FragmentSpread",
        "name": "IgnoredTombstoneOrHideContainer_comment"
    } as any), v4 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enteredLive",
        "storageKey": null
    } as any), v5 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [
            {
                "defaultValue": 20,
                "kind": "LocalArgument",
                "name": "count"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            },
            {
                "defaultValue": "CREATED_AT_DESC",
                "kind": "LocalArgument",
                "name": "orderBy"
            },
            {
                "defaultValue": "UNANSWERED",
                "kind": "LocalArgument",
                "name": "tag"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "count",
                    "cursor": "cursor",
                    "direction": "forward",
                    "path": [
                        "comments"
                    ]
                }
            ]
        },
        "name": "UnansweredCommentsTabContainer_story",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isClosed",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "StorySettings",
                "kind": "LinkedField",
                "name": "settings",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "LiveConfiguration",
                        "kind": "LinkedField",
                        "name": "live",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "enabled",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentCounts",
                "kind": "LinkedField",
                "name": "commentCounts",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentTagCounts",
                        "kind": "LinkedField",
                        "name": "tags",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "UNANSWERED",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": "comments",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "orderBy",
                        "variableName": "orderBy"
                    },
                    {
                        "kind": "Variable",
                        "name": "tag",
                        "variableName": "tag"
                    }
                ],
                "concreteType": "CommentsConnection",
                "kind": "LinkedField",
                "name": "__UnansweredStream_comments_connection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Comment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "__typename",
                                        "storageKey": null
                                    },
                                    (v1 /*: any*/),
                                    (v2 /*: any*/),
                                    (v3 /*: any*/),
                                    {
                                        "kind": "ClientExtension",
                                        "selections": [
                                            (v4 /*: any*/)
                                        ]
                                    }
                                ],
                                "storageKey": null
                            },
                            (v5 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endCursor",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasNextPage",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CommentEdge",
                                "kind": "LinkedField",
                                "name": "viewNewEdges",
                                "plural": true,
                                "selections": [
                                    (v5 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Comment",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            (v4 /*: any*/),
                                            (v0 /*: any*/),
                                            (v1 /*: any*/),
                                            (v2 /*: any*/),
                                            (v3 /*: any*/)
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ]
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PostCommentFormContainer_story"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CommentContainer_story"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReplyListContainer1_story"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CreateCommentReplyMutation_story"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CreateCommentMutation_story"
            }
        ],
        "type": "Story",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'e7a792b1d19c86374d1215f181922d18';
export default node;
